var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AntPagination',{attrs:{"total":_vm.total,"pageSize":6,"size":"small","showTotal":(total, range) => `Zeige ${range[0]}-${range[1]} von ${total} Firmen`},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }